/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ style: NonNullable<unknown> }} Style_Overrides_Auto_DescriptionInputs */

const fr_style_overrides_auto_description = /** @type {(inputs: Style_Overrides_Auto_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Ajoutez une balise ${i?.style} à l'intérieur du conteneur :`)
};

const en_style_overrides_auto_description = /** @type {(inputs: Style_Overrides_Auto_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Add a ${i?.style} tag inside the container:`)
};

/**
* | output |
* | --- |
* | "Add a {style} tag inside the container:" |
*
* @param {Style_Overrides_Auto_DescriptionInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const style_overrides_auto_description = /** @type {((inputs: Style_Overrides_Auto_DescriptionInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Style_Overrides_Auto_DescriptionInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_style_overrides_auto_description(inputs)
	return en_style_overrides_auto_description(inputs)
});